import LdcApi from '../../LdcApis';
// import { useNavigate } from 'react-router-dom';
const user = JSON.parse(localStorage.getItem('user'));
const userInfo = JSON.parse(localStorage.getItem('user_info'));

// const navigate = useNavigate();
// https://api-ldc.goldenbuzz.in/api/Appointment/GetAppointmentbyDoctorId?doctorId=8&date=2022-12-18

// Appointment/GetAppointmentbyDoctorId?doctorId=0&date=${selectDateApt} ...today api ..
// Appointment/GetAppointmentByDate?date=${selectDateApt} ... past api

// https://api-ldc.goldenbuzz.in/api/Appointment/GetAppointmentByDate?date=2022-12-18&doctorId=0    letest api

class BookAppointMent {
  getAppointMents = (selectDateApt, callback) => {
    LdcApi({
      method: 'GET',
      url: `Appointment/GetAppointmentByDate?date=${selectDateApt}&doctorId=${
        (userInfo && userInfo?.roleID == 1) ||
        userInfo?.roleID == 2 ||
        userInfo?.roleID == 3 ||
        userInfo?.roleID == 5 ||
        userInfo?.roleID == 11 ||
        userInfo?.roleID == 13
          ? user.id
          : 0
      }`,
    })
      .then((response) => {
        if (response?.data) {
          callback({ status: 'success', data: response?.data });
        }
      })
      .catch((error) => {
        callback({ status: 'error' });
      });
  };

  // getAppointMentsByDocID = (selectDateApt, callback) => {
  //   LdcApi({
  //     method: 'GET',
  //     url: `Appointment/GetAppointmentbyDoctorId?doctorId=${
  //       (userInfo && userInfo?.roleID == 1) || userInfo?.roleID == 2 || userInfo?.roleID == 3 || userInfo?.roleID == 5 ? user.id : 0
  //     }&date=${selectDateApt}`
  //   })
  //     .then((response) => {
  //       if (response?.data) {
  //         callback({ status: 'success', data: response?.data });
  //       }
  //     })
  //     .catch((error) => {
  //       callback({ status: 'error' });
  //     });
  // };
  getProvisionalAppointMents = (callback) => {
    LdcApi({
      method: 'GET',
      url: `Appointment/GetAppointmentByProvision`,
    })
      .then((response) => {
        if (response?.data) {
          callback({ status: 'success', data: response?.data });
        }
      })
      .catch((error) => {
        callback({ status: error });
      });
  };
  getProvisionalAppointMentsByID = (roleID, callback) => {
    LdcApi({
      method: 'GET',
      url: `Appointment/GetProvisionalAppointmentsbyDoctorId?doctorId=${roleID}`,
    })
      .then((response) => {
        if (response?.data) {
          callback({ status: 'success', data: response?.data });
        }
      })
      .catch((error) => {
        callback({ status: error });
      });
  };
  getReviewForAppointMents = (callback) => {
    LdcApi({
      method: 'GET',
      url: `Appointment/GetAppointmentReviews`,
    })
      .then((response) => {
        if (response?.data) {
          callback({ status: 'success', data: response?.data });
        }
      })
      .catch((error) => {
        callback({ status: error });
      });
  };

  addAppointMent = (appointMentData, callback) => {
    LdcApi({
      method: 'POST',
      url: 'Appointment/AddAppointment',
      data: appointMentData,
    })
      .then((response) => {
        if (response?.data) {
          callback({ status: 'success', data: response?.data });
        }
      })
      .catch((error) => {
        callback({ status: 'error' });
      });
  };
  deleteBlockAppointMent = (id, callback) => {
    LdcApi({
      method: 'GET',
      url: `ServiceMaster/DeleteServiceMasterData?id=${id}`,
    })
      .then((response) => {
        callback({ status: 'success', data: response?.data });
      })
      .catch((error) => {
        callback({ status: 'error' });
      });
  };
  deleteAppointMent = (id, data, callback) => {
    let newData = {
      cancelReason: data.cancelReason ? data.cancelReason : null,
      smsNotify: data.smsNotify ? data.smsNotify : false,
      emailNotify: data.emailNotify ? data.emailNotify : false,
    };

    LdcApi({
      method: 'GET',
      url: `Appointment/DeleteAppointment?id=${id}&cancelReason=${newData.cancelReason}&smsConfirmation=${newData.smsNotify}&emailConfirmation=${newData.emailNotify}`,
    })
      .then((response) => {
        if (response?.data) {
          callback({ status: 'success', data: response?.data });
        }
      })
      .catch((error) => {
        callback({ status: 'error' });
      });
  };
// BookAppointment.js or wherever it's defined
received = (id, sendBy, isReceived, callback) => {
  console.log('Received Params:', { id, sendBy, isReceived });
  const test = 'Gracie'
  const received = !isReceived;
  console.log('received', received)

  LdcApi({
    method: 'POST',
    url: `Appointment/ReceivedBy?id=${id}&sendBy=${sendBy}&isReceived=${received}`,
  })
    .then((response) => {
      console.log('API response', response);
      if (response?.data) {
        callback({ status: 'success', data: response.data });
      } else {
        callback({ status: 'error' });
      }
    })
    .catch((error) => {
      console.error('API Error:', error);
      callback({ status: 'error' });
    });
};

  updateAppointMent = (appointMentData, callback) => {
    LdcApi({
      method: 'POST',
      url: 'Appointment/AddAppointment',
      data: appointMentData,
    })
      .then((response) => {
        if (response?.data) {
          callback({ status: 'success', data: response?.data });
        }
      })
      .catch((error) => {
        callback({ status: 'error' });
      });
  };
  // https://api-ldc.goldenbuzz.in/api/Appointment/ResheduleAppointment
  // rescheduleAppointment = (appointMentData, callback) => {
  //   LdcApi({
  //     method: 'POST',
  //     url: 'Appointment/ResheduleAppointment',
  //     data: appointMentData
  //   })
  //     .then((response) => {
  //       if (response?.data) {
  //         callback({ status: 'success', data: response?.data });
  //       }
  //     })
  //     .catch((error) => {
  //       callback({ status: 'error' });
  //     });
  // };
  getInvoiceByAppointMentId = (id, callback) => {
    LdcApi({
      method: 'GET',
      url: `Invoice/GetInvoiceByAppointmentId?appointmentId=${id}`,
    })
      .then((response) => {
        if (response?.data) {
          callback({ status: 'success', data: response?.data });
        }
      })
      .catch((error) => {
        callback({ status: 'error' });
      });
  };
}

export default new BookAppointMent();
